import { render } from "./SaleStatusBadge.vue?vue&type=template&id=2d8ba0a6&scoped=true"
import script from "./SaleStatusBadge.vue?vue&type=script&lang=js"
export * from "./SaleStatusBadge.vue?vue&type=script&lang=js"

import "./SaleStatusBadge.vue?vue&type=style&index=0&id=2d8ba0a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8ba0a6"]])

export default __exports__